import {
  type FetchQueryOptions,
  type QueryClient,
} from '@tanstack/react-query';
import { sanityClient } from '../consts/client.const';
import type { RouteProps } from 'react-router';
import type { Settings } from '../types/settings.type';

export const settingsQueryOptions = (): FetchQueryOptions<Settings> => ({
  queryKey: ['SETTINGS'],
  queryFn: () => {
    const query = `
        *[_type == "siteSettings"][0]{
          email,
          location{ lng, lat },
          title,
          phoneNumber,
          socialMedia[]{ _key, url, name }
        }
      `;
    const params = { lang: 'pl' };

    return sanityClient.fetch<Settings>(query.replace(/\s/g, ''), params);
  },
});

export const settingsLoader =
  (queryClient: QueryClient): RouteProps['loader'] =>
  async () => {
    const queryOptions = settingsQueryOptions();

    return (
      queryClient.getQueryData(queryOptions.queryKey) ??
      (await queryClient.fetchQuery(queryOptions))
    );
  };
